export default __webpack_public_path__ + "static/media/store-bag.7f53d9e4.svg";